import React from 'react';

export function getInventoryIconPath(itemId: string): string {
  return `/icons/inventory/${itemId.replace(/_/g, '-')}.png`;
}

interface InventoryIconProps {
  itemId: string;
  className?: string;
}

export const InventoryIcon: React.FC<InventoryIconProps> = ({ itemId, className = 'w-10 h-10' }) => {
  return (
    <img
      src={getInventoryIconPath(itemId)}
      alt={itemId.replace(/_/g, ' ')}
      className={`${className} object-contain`}
      onError={(e) => {
        (e.target as HTMLImageElement).src = '/icons/inventory/default.png';
      }}
    />
  );
};
